import React, { useEffect, useState } from 'react'
import Sidebarlayout from '../../Layouts/Sidebarlayout'
import '../../Assets/Css/AddUpdateClient.scss'
import { customStyle } from '../../Components/Style'
import Select from 'react-select'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { getShareholdersList } from '../../Services/Shareholders/action'
import { connect } from 'react-redux'
import { getInvoicesList } from '../../Services/Invoices/action'
import { addClient, updateClients } from '../../Services/Clients/action'
import { toast } from 'react-toastify'
import { useLocation, useNavigate } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'

const initialState = {
  title: null,
  name: '',
  email: '',
  mobile: '',
  notes: '',
  address1: '',
  address2: '',
  city: '',
  state: '',
  country: '',
  postalcode: '',
  internal: false,
  contact_by: null,
  managed_by: null,
  clientInvoices: []
}
const optionType = [
  { value: 'mr', label: 'mr' },
  { value: 'mrs', label: 'mrs' },
  { value: 'ms', label: 'ms' },
];

const AddUpdateClient = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const data = location?.state?.data;
  const invoicesId = data?.allData?.clientInvoices.map(item => item.id);
  const [shareholderOption, setShareholderOption] = useState([]);
  const [invoicesOption, setInvoicesOption] = useState([]);
  const [clientData, setClientData] = useState(initialState);
  const [isUpdate, setIsUpdate] = useState(false);
  const [deletedInvoices, setDeletedInvoices] = useState([]);
  const [updateInvoices, setUpdateInvoices] = useState([]);

  const getShareholderOption = async () => {
    try {
      await props.getShareholdersList();
    } catch (error) {
      console.log(error);
    }
  }
  const getInvoicesForSelect = async () => {
    try {

      await props.getInvoicesList();
    } catch (error) {
      console.log("Error while Getting Invoices List");
    }
  }

  useEffect(() => {
    getShareholderOption();
    getInvoicesForSelect();
    if (data?.ClientId?.value) {
      setIsUpdate(true);
      setClientData({
        title: optionType.find(item => item.value == data.allData.title),
        name: data.allData.name,
        email: data.allData.email,
        mobile: data.allData.mobile,
        notes: data.allData.notes,
        address1: data.allData.address1,
        address2: data.allData.address2,
        city: data.allData.city,
        state: data.allData.state,
        country: data.allData.country,
        postalcode: data.allData.postalcode,
        internal: data.allData.internal,
        contact_by: data.allData.contact_by,
        managed_by: shareholderOption.find(item => item.value === data.allData.managed_by),
        clientInvoices: invoicesOption.filter((item) => invoicesId.includes(item.value))
      })

    } else if (data?.ClientId?.value === undefined && isUpdate) {
      toast.error("Something Went Wrong !");
      navigate("/clients");
    }
  }, [])

  useEffect(() => {
    const options = props.shareholdersList?.map((item) => {
      return { value: item.id, label: item.name }
    })
    setShareholderOption(options);
    if (isUpdate) {
      setClientData((preVal) => ({
        ...preVal,
        managed_by: options.find(item => item.value === data.allData.managed_by),
      }))
    }
  }, [props.shareholdersList])

  useEffect(() => {
    const options = props.invoicesList?.map(items => {
      return {
        value: items?.id,
        label: items?.title
      }
    })
    setInvoicesOption(options)
    if (isUpdate) {
      setClientData((preVal) => ({
        ...preVal,
        clientInvoices: options.filter((item) => invoicesId.includes(item.value)),
      }))
    }
  }, [props.invoicesList])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setClientData((preVal) => ({
      ...preVal,
      [name]: value
    }))
  }

  const changeInvoices = (oldVal, newVal) => {
    const oldValMap = new Map(oldVal.map(invoice => [invoice.value, invoice]));
    newVal.forEach(newInvoices => {
      const { value } = newInvoices;

      // If Transaction in the old List
      if (oldValMap.has(value)) {
        // Remove it from oldInvoices
        oldValMap.delete(value);
      } else {
        // If invoices is not in the old List, its' new one
        if (newInvoices.deleted_at) {
          delete newInvoices.deleted_at;
        }
        setUpdateInvoices(preVal => [...preVal, newInvoices])
      }
    });

    oldValMap.forEach(deletedIn => {
      deletedIn.deleted_at = Date.now();
      // Check if shareholder is already in deletedShareholders
      const existingIndex = deletedInvoices.findIndex(sh => sh.value === deletedIn.value);
      if (existingIndex === -1) {
        setDeletedInvoices(preVal => [...preVal, deletedIn]);
      } else {
        deletedInvoices[existingIndex].deleted_at = deletedIn.deleted_at;
      }
    })
  }

  const onInvoiceChange = (val) => {
    const oldInvoice = clientData.clientInvoices;
    setClientData((preVal) => ({

      ...preVal,
      clientInvoices: val
    }))
    changeInvoices(oldInvoice, val);
  }

  const isEmptyField = () => {
    const { contact_by, internal, notes, address2, email, ...requiredFields } = clientData;
    for (const key in requiredFields) {
      if (requiredFields[key] === "" || requiredFields[key] === null) {
        toast.error("All Fields Must be Required !");
        return true;
      }
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;
    if (clientData.email && !emailRegex.test(clientData.email)) {
      toast.error("Please Enter Valid Email!");
      return true;
    }
    // if (!phoneRegex.test(clientData.mobile)) {
    //   toast.error("Please Enter Valid Mobile Number!");
    //   return true;
    // }
    return false;
  }

  const handleSubmit = async () => {
    try {
      if (isEmptyField()) {
        return;
      }
      // Update Clients
      if (isUpdate) {
        let { managed_by, clientInvoices, ...inputData } = clientData;
        // Formatting for Invoices
        const newInvoice = updateInvoices?.map(items => ({ id: items.value, client_id: data?.ClientId?.value }));
        let deletedInvoicesList = deletedInvoices.filter(item => item.deleted_at).map(items => ({ id: items.value, client_id: null }));

        const putData = {
          ...inputData,
          managed_by: clientData.managed_by.value,
          title: clientData.title.value,
          clientInvoices: [...newInvoice, ...deletedInvoicesList],
          id: data?.ClientId?.value
        }
        await props.updateClients(data?.ClientId?.value, putData);
      } else {
        // Add Client
        const postData = {
          ...clientData,
          managed_by: clientData.managed_by.value,
          title: clientData.title.value,
          clientInvoices: clientData.clientInvoices.map((item) => ({ id: item.value }))
        }
        await props.addClient(postData);
        setClientData(initialState);
      }
    } catch (error) {
      toast.error(error);
    }
  }

  return (
    <Sidebarlayout>
      <div className="addUpdateClient-main">
        <div className="page-title">
          <h4> {isUpdate ? "Update" : "Add"} Client</h4>
          <div className="edit-btn">
            <button className="custom-btn" onClick={handleSubmit}>
              {props.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : "save"}
            </button>
          </div>
        </div>
        <div className="content-part">
          <div className="row">
            <div className="col-lg-8">
              <div className="left-part">
                <div className="custom-row">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="input-group">
                        <h6 className='label'>Title</h6>
                        <Select
                          options={optionType}
                          styles={customStyle}
                          value={clientData.title}
                          onChange={(val) => {
                            setClientData((preVal) => ({
                              ...preVal,
                              title: val
                            }))
                          }}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#5757fe",
                              primary: "#5757fe",
                            },
                          })}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-group">
                        <h6 className='label'>Name</h6>
                        <input type="text" className="input-css" name='name' disabled={props.loading} value={clientData.name} onChange={handleChange} />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-group">
                        <h6 className='label'>Email</h6>
                        <input type="text" className="input-css" name='email' disabled={props.loading} value={clientData.email} onChange={handleChange} />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-group">
                        <h6 className='label'>Mobile</h6>
                        <input type="text" className="input-css" name='mobile' disabled={props.loading} value={clientData.mobile} onChange={handleChange} />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-group">
                        <h6 className='label'>Address 1</h6>
                        <input type="text" className="input-css" name='address1' disabled={props.loading} value={clientData.address1} onChange={handleChange} />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-group">
                        <h6 className='label'>Address 2</h6>
                        <input type="text" className="input-css" name="address2" disabled={props.loading} value={clientData.address2} onChange={handleChange} />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-group">
                        <h6 className='label'>City</h6>
                        <input type="text" className="input-css" name='city' disabled={props.loading} value={clientData.city} onChange={handleChange} />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-group">
                        <h6 className='label'>State</h6>
                        <input type="text" className="input-css" name='state' disabled={props.loading} value={clientData.state} onChange={handleChange} />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-group">
                        <h6 className='label'>Country</h6>
                        <input type="text" className="input-css" name='country' disabled={props.loading} value={clientData.country} onChange={handleChange} />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-group">
                        <h6 className='label'>Postal Code</h6>
                        <input type="text" className="input-css" name='postalcode' disabled={props.loading} value={clientData.postalcode} onChange={handleChange} />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-group">
                        <h6 className='label'>Contact By</h6>
                        <input type="text" className="input-css" name='contact_by' disabled={props.loading} value={clientData.contact_by} onChange={handleChange} />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div class="checkbox switch">
                        <label>
                          <input type="checkbox" class="switch-control" name='internal' disabled={props.loading} checked={clientData.internal} onChange={(e) => {
                            setClientData((preVal) => ({
                              ...preVal,
                              internal: e.target.checked
                            }))
                          }} />
                          <span class="switch-label"> Internal </span>
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="note-part">
                        <h6 className="label">Notes</h6>
                        <div className="editor-custom">
                          <CKEditor
                            editor={ClassicEditor}
                            // data={clientData.notes}
                            onReady={editor => {
                              console.log('Editor is ready to use!', editor);
                            }}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              console.log({ event, editor, data });
                              setClientData((preVal) => ({
                                ...preVal,
                                notes: data
                              }))
                            }}
                            onBlur={(event, editor) => {
                              console.log('Blur.', editor);
                            }}
                            onFocus={(event, editor) => {
                              console.log('Focus.', editor);
                            }}
                          />
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="right-part">
                <div className="card-type">
                  <h6 className='label'>Managed By</h6>
                  <Select
                    options={shareholderOption}
                    styles={customStyle}
                    disabled={props.loading}
                    onChange={(val) => {
                      setClientData((preVal) => ({
                        ...preVal,
                        managed_by: val
                      }))
                    }}
                    value={clientData.managed_by}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#5757fe",
                        primary: "#5757fe",
                      },
                    })}
                  />
                </div>
                <div className="card-type">
                  <h6 className="label">Invoice</h6>
                  <Select
                    options={invoicesOption}
                    styles={customStyle}
                    disabled={props.loading}
                    value={clientData.clientInvoices}
                    onChange={(val) => {
                      onInvoiceChange(val);
                    }}
                    isMulti
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#5757fe",
                        primary: "#5757fe",
                      },
                    })}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Sidebarlayout>
  )
}
const mapStateToProps = (state) => {
  return {
    loading: state.clientsReducer.loading,
    shareholdersList: state.shareholdersReducer.shareholderslist,
    invoicesList: state.invoicesReducer.invoiceslist,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getShareholdersList: () => {
      dispatch(getShareholdersList());
    },
    getInvoicesList: () => {
      dispatch(getInvoicesList());
    },
    addClient: (data) => {
      dispatch(addClient(data))
    },
    updateClients: (id, data) => {
      dispatch(updateClients(id, data))
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(AddUpdateClient);
